export function downloadFile(content, format, fileName) {
    const hiddenElement = document.createElement('a')
    hiddenElement.href = `data:${format};charset=utf-8,${encodeURIComponent(content)}`
    hiddenElement.target = '_blank'
    hiddenElement.download = fileName
    hiddenElement.click()
    hiddenElement.remove()
}
